const SPLIT_BLOCK_SEPARATOR = '__split__';

export const createSplitBlockId = (value: string | number, suffix: string) =>
    `${String(value)}${SPLIT_BLOCK_SEPARATOR}${suffix}`;

export const stripSplitBlockId = (value?: string | number) => {
    if (value === null || value === undefined) return '';

    return String(value)
        .replace(/__split__.*$/, '')
        .replace(/-part-\d+(-rem)?$/, '');
};

export const isSplitBlockId = (value?: string | number) => {
    if (value === null || value === undefined) return false;

    const raw = String(value);
    return raw.includes(SPLIT_BLOCK_SEPARATOR) || /-part-\d+(-rem)?$/.test(raw);
};

// A "continuation" fragment is the tail of a block that overflowed from a previous
// page (its visible top is mid-block), as opposed to a head fragment that begins a
// block on this page. Used to suppress the "before" drop target above a continuation.
export const isSplitContinuationId = (value?: string | number) => {
    if (value === null || value === undefined) return false;

    const raw = String(value);
    return raw.includes(`${SPLIT_BLOCK_SEPARATOR}remaining`) || /-part-\d+-rem$/.test(raw);
};

// Locate the rendered element for a real block id, split-aware: a split block's
// DOM attribute carries the fragment id (`<realId>__split__<suffix>`), so an
// exact-id query misses it. First match in document order = the head fragment.
// Cross-id prefix over-match is impossible — fragment ids always append the
// separator to the FULL real id.
export const findBlockElement = (root: ParentNode, realId: string | number): HTMLElement | null => {
    const escaped = CSS.escape(String(realId));

    return root.querySelector<HTMLElement>(
        `[data-preview-block-id="${escaped}"], [data-preview-block-id^="${escaped}${SPLIT_BLOCK_SEPARATOR}"]`,
    );
};

export const getBlockMeasurementId = (value: string | number) =>
    `block-${stripSplitBlockId(value)}`;

export const getTableMeasurementId = (measurementId: string) => `${measurementId}-table`;

export const getTableDescriptionMeasurementId = (measurementId: string) =>
    `${measurementId}-description`;

export const getTableHeadMeasurementId = (measurementId: string) => `${measurementId}-head`;

export const getTableRowMeasurementId = (measurementId: string, rowId: string) =>
    `${measurementId}-row-${rowId}`;
